import { FAQ, Podcast, Post } from 'src/components/models';
import { WebsiteContentLinkDTO, WebsitePostCategoryDTO } from 'src/services/generated/api.generated.v1';
import { MutationTree } from 'vuex';
import { ConsumerInformationInterface } from './state';

const mutation: MutationTree<ConsumerInformationInterface> = {
    updateContentLinksState(state: ConsumerInformationInterface, websiteContentLinks: WebsiteContentLinkDTO | null) {
        state.contentLinks = websiteContentLinks;
    },

    updatePostCategoriesState(state: ConsumerInformationInterface, websitePostCategories: Array<WebsitePostCategoryDTO> | null) {
        state.postCategories = websitePostCategories;
    },

    updateBlogPostsState(state: ConsumerInformationInterface, posts: Array<Post> | null) {
        state.allPosts = posts;
    },

    updateFAQsState(state: ConsumerInformationInterface, faq: FAQ | null) {
        state.frequentlyAskedQuestions = faq;
    },

    updatePodcastsState(state: ConsumerInformationInterface, podcasts: Array<Podcast> | null) {
        state.podcasts = podcasts;
    },
}

export default mutation;